import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import { MoneyScaled } from '@quickbit/qb-design-system';
import { TransactionMinimal } from 'components/Transactions/api';

export interface Pagination {
  page: number;
  size: number;
}
export interface CorporateWalletTransactionFilters {
  page: number;
  dateFilterRange: [Date | null, Date | null];
}
export interface CorporateWalletTransactionsApiFilters {
  createdFrom: Date | null;
  createdTo: Date | null;
}

export const initialFilterState: CorporateWalletTransactionFilters = {
  page: 1,
  dateFilterRange: [null, null],
};

export const getInitialFilterState = (
  params: URLSearchParams
): CorporateWalletTransactionFilters => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const paramDateFilterRange = params.get('dateFilterRange')
    ? JSON.parse(params.get('dateFilterRange') as string)
    : undefined;
  return {
    page: Number(params.get('page')) || 1,
    dateFilterRange: paramDateFilterRange
      ? [
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
          paramDateFilterRange[0] ? new Date(paramDateFilterRange[0]) : null,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
          paramDateFilterRange[1] ? new Date(paramDateFilterRange[1]) : null,
        ]
      : [null, null],
  };
};
export interface SortOptions {
  field: 'CREATED_AT' | 'TYPE' | 'AMOUNT' | 'NETWORK_FEE';
  ascending: boolean;
}
export interface TransactionAggregateData {
  count: number;
}

interface AuthorizedBy {
  email: string;
}

export interface CorporateWalletTransaction extends TransactionMinimal {
  authorizedBy?: AuthorizedBy;
}

export interface CorporateWalletTransactionsResponse {
  transactions: CorporateWalletTransaction[];
  aggregatedData: TransactionAggregateData;
  addresses: Record<string, string>;
  balances?: Record<string, Record<string, MoneyScaled>>;
}
export const getCorporateWalletTransactions = async ({
  merchantId,
  filters,
  pagination,
}: {
  merchantId: string;
  filters?: CorporateWalletTransactionsApiFilters;
  pagination?: Pagination;
}) => {
  const convertedFilters = filters && {
    ...filters,
    createdFrom: filters.createdFrom ? filters.createdFrom.toISOString() : null,
    createdTo: filters.createdTo ? filters.createdTo.toISOString() : null,
  };

  const queryParams = new URLSearchParams();
  if (convertedFilters) {
    Object.entries(convertedFilters).forEach(([key, value]) => {
      if (value) {
        queryParams.append(`filter_${key}`, value);
      }
    });
  }
  if (pagination) {
    queryParams.append('page', pagination.page.toString());
    queryParams.append('size', pagination.size.toString());
  }

  const response = await fetchAPI<CorporateWalletTransactionsResponse>(
    `v1/merchants/${merchantId}/corporate-wallet-transactions?${queryParams.toString()}`,
    {
      method: 'GET',
    }
  );
  return {
    ...response,
    transactions: response.transactions.map((transaction) => ({
      ...transaction,
      createdAt: new Date(transaction.createdAt),
      updatedAt: new Date(transaction.updatedAt),
    })),
  };
};
